<template>
  <div class="goTop" v-if="showButton" @click="scrollToTop"></div>
</template>
<script>
export default {
  // showButton: false,
  data() {
    return {
      showButton: false,
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 可选，添加平滑滚动效果
      });
    },
    handleScroll() {
      const currentScrollPosition = window.pageYOffset;
      if (currentScrollPosition > 700) {
        this.showButton = true;
      } else {
        this.showButton = false;
      }
    }
  }

}
</script>
<style lang="scss" scoped>
.goTop {
  width: 50rem;
  height: 50rem;
  position: fixed;
  bottom: 10%;
  right: 50rem;
  display: flex;
  justify-content: center;
  z-index: 20;
  background: url("../../../assets/icon/goTop_icon.png");
  background-size: 100% 100%;
  cursor: pointer;
  border-radius: 100%;
  // box-shadow: 0rem 0rem 5rem 5rem rgba(67, 66, 66, 0.1);
}

.goTop:hover {
  background: url("../../../assets/icon/goTop_icon_high.png");
  background-size: 100% 100%;
  box-shadow: 0rem 0rem 10rem 10rem rgba(231, 227, 227, 0.05);
}
</style>